const TARGET_SELECTOR = '[data-home-address-same-as-service-address]';
const HOME_ADDRESS_FIELDS_SELECTOR = '[data-home-address-same-as-service-address-fields]';
const CHECKBOX_SELECTOR = 'input[type="checkbox"]';

class HomeAddressSameAsService {
  constructor() {

    this.attachEventHandlers();
  }

  attachEventHandlers() {
    $(TARGET_SELECTOR)
      .on('change', CHECKBOX_SELECTOR, this.onCheckboxChange.bind(this))
      .find(CHECKBOX_SELECTOR)
      .trigger('change');
  }

  onCheckboxChange(event) {
    const isChecked = $(event.target).is(':checked');

    this.toggleAddressFields(isChecked);
  }

  toggleAddressFields(showOrHide) {
    $(HOME_ADDRESS_FIELDS_SELECTOR)
      .toggle(!showOrHide)
      .closest('fieldset')
      .attr('disabled', showOrHide);
  }
}

export default HomeAddressSameAsService;



// WEBPACK FOOTER //
// ./src/javascripts/HomeAddressSameAsService.js